import dayjs from "dayjs";
import { OVERRIDE_SOURCES } from "../../enums/override_enum";

export function inThePast(valid_to_ts) {
  if (valid_to_ts === null) return false;
  const valid_to = dayjs.unix(valid_to_ts);
  return dayjs().isAfter(valid_to);
}

export function inTheFuture(valid_from_ts) {
  if (valid_from_ts === null) return false;
  const valid_from = dayjs.unix(valid_from_ts);
  return dayjs().isBefore(valid_from);
}

export const fadeOverride = (override) => {
  return inThePast(override.valid_to_utc) || inTheFuture(override.valid_from_utc) || !override.enabled;
};

export const clearableOverride = (override) => {
  if (!override.enabled) return false;
  if (override.source && override.source.toLocaleUpperCase() === OVERRIDE_SOURCES.COMMISSIONING.toLocaleUpperCase()) {
    return false;
  }
  return override.enabled && (override.valid_to_utc === null || !inThePast(override.valid_to_utc));
};

const fmtDt = (d) => {
  return (
    ("0" + d.getDate()).slice(-2) +
    "-" +
    ("0" + (d.getMonth() + 1)).slice(-2) +
    " " +
    ("0" + d.getHours()).slice(-2) +
    ":" +
    ("0" + d.getMinutes()).slice(-2)
  );
};

export function formatDate(from, to) {
  const now = dayjs();
  const validFrom = dayjs.unix(from);

  if (!from && !to) {
    return "Always";
  }
  if (!from && to) {
    const d = new Date(to * 1000);
    return "Until " + fmtDt(d);
  }
  if (from && !to) {
    const d = new Date(from * 1000);
    if (now.isAfter(validFrom)) return "Since " + fmtDt(d);
    else return "Starting on " + fmtDt(d);
  }
  const d = new Date(from * 1000);
  const t = new Date(to * 1000);
  return fmtDt(d) + " - " + fmtDt(t);
}
